/*
  Wellstore accessibility helpers.
  Mobile swipe rows (.swipe-mobile) become horizontal scrollers. When a row has no focusable content
  (e.g. the "Perché scegliere Wellstore" icon cards), keyboard users cannot scroll it (WCAG 2.1.1).
  While such a row actually overflows, expose it as a named, focusable region; remove that again
  when it stops overflowing (desktop grid), so it never adds an empty tab stop.
*/
(() => {
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, iframe, [tabindex]:not([tabindex^="-"])';
  const MARKER = 'data-ws-scroll-region';

  const labelFor = (scroller) => {
    const section = scroller.closest('.section') || scroller.closest('.shopify-section');
    const heading = section && section.querySelector('h1, h2, h3, h4, h5, h6');
    if (heading && heading.textContent.trim()) {
      if (!heading.id) heading.id = `${scroller.dataset.sectionId || 'ws-scroll'}-heading`;
      return { labelledby: heading.id };
    }
    return null;
  };

  const update = (scroller) => {
    const overflows = scroller.scrollWidth - scroller.clientWidth > 1;
    const managed = scroller.hasAttribute(MARKER);
    const hasFocusable = Array.from(scroller.querySelectorAll(FOCUSABLE)).some((el) => el.getClientRects().length);

    if (overflows && !hasFocusable && !managed) {
      const label = labelFor(scroller);
      if (!label) return;
      scroller.setAttribute(MARKER, '');
      scroller.setAttribute('tabindex', '0');
      scroller.setAttribute('role', 'region');
      scroller.setAttribute('aria-labelledby', label.labelledby);
    } else if ((!overflows || hasFocusable) && managed) {
      scroller.removeAttribute(MARKER);
      scroller.removeAttribute('tabindex');
      scroller.removeAttribute('role');
      scroller.removeAttribute('aria-labelledby');
    }
  };

  const init = () => {
    const scrollers = document.querySelectorAll('.swipe-mobile');
    if (!scrollers.length) return;
    // Observe the scroller and its track: the track grows when lazy content lays out.
    const observer = new ResizeObserver((entries) =>
      entries.forEach((entry) => update(entry.target.closest('.swipe-mobile')))
    );
    scrollers.forEach((scroller) => {
      observer.observe(scroller);
      if (scroller.firstElementChild) observer.observe(scroller.firstElementChild);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
